// this component will be the standard layout used across pages
import React from "react"
import Head from "./head"
import Header from "./header"
import Footer from "./footer"
import FooterBM from "./footerBM"
import Alert from "./alert"
import HeadBM from "./headBM"

const Layout = ({pageTitle, children, isLanding, lang}) => <>
	{lang.id === 'EN' && <Head pageTitle={pageTitle} />}
	{lang.id === 'BM' && <HeadBM pageTitle={pageTitle} />}
	<Header lang={lang}/>
	{/* children is a standard naming for everything you place inside the component, 
	so we put it below as we want the content to be in the middle */}
	<div className="">
		{children}
	</div>
	{lang.id === 'EN' && <Footer isLanding={isLanding} lang={lang} />}
	{lang.id === 'BM' && <FooterBM isLanding={isLanding} lang={lang} />}
		 {/* <Alert /> */}
</>

export default Layout